import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomeComponent } from './home/home.component';
import { AboutComponent } from './about/about.component';
import { ContactComponent } from './contact/contact.component';
import { TranslationComponent } from './translation/translation.component';
import { ListTranslationComponent } from './translation/list-translation/list-translation.component';
import { EditTranslationComponent } from './translation/edit-translation/edit-translation.component';
import { CreateTranslationComponent } from './translation/create-translation/create-translation.component';
import { ListDealerComponent } from './dealer/list-dealer/list-dealer.component';
import { EditDealerComponent } from './dealer/edit-dealer/edit-dealer.component';
import { DealerDetailsComponent } from './dealer/dealer-details/dealer-details.component';
import { SignupComponent } from './auth/signup/signup.component';
import { LoginComponent } from './auth/login/login.component';
import { AuthGuard } from './auth/auth.guard';
import { AdmakerComponent } from './admaker/admaker.component';
import { ProcessRunnerComponent } from './process-runner-select/process-runner.component';
import { ProcessRunComponent } from './process-runner-select/process-run/process-run.component';
import { ProcesslogComponent } from './processlog/processlog.component';
import { ProcessLogsClientComponent } from './process-logs-client/process-logs-client.component';
import { MissingFieldsComponent } from './missing-fields/missing-fields.component';
import { MissingFieldsClientComponent } from './missing-fields/missing-fields-client/missing-fields-client.component';
import { AncSettingsComponent } from './anc-settings/anc-settings.component';
import { SeedShowComponent } from './seed/seed-show/seed-show.component';
import { SeedShowDealerComponent } from './seed/seed-show-dealer/seed-show-dealer.component';


const routes: Routes = [
  { path: '', component: HomeComponent },
  { path: 'about', component: AboutComponent },
  { path: 'contact', component: ContactComponent },
  { path: 'translation', component: TranslationComponent, canActivate: [AuthGuard] },
  { path: 'listtrans', component: ListTranslationComponent, canActivate: [AuthGuard] },
  { path: 'edittrans', component: EditTranslationComponent, canActivate: [AuthGuard] },
  { path: 'createtrans', component: CreateTranslationComponent, canActivate: [AuthGuard] },
  { path: 'listdealers', component: ListDealerComponent, canActivate: [AuthGuard] },
  { path: 'editdealer', component: EditDealerComponent, canActivate: [AuthGuard] },
  { path: 'dealerdetails', component: DealerDetailsComponent, canActivate: [AuthGuard] },
  { path: 'process-select', component: ProcessRunnerComponent, canActivate: [AuthGuard] },
  { path: 'processlog', component: ProcesslogComponent, canActivate: [AuthGuard] },
  { path: 'processlogclie', component: ProcessLogsClientComponent, canActivate: [AuthGuard] },
  { path: 'missingField', component: MissingFieldsComponent, canActivate: [AuthGuard] },
  { path: 'missingFieldClient', component: MissingFieldsClientComponent, canActivate: [AuthGuard] },
  { path: 'process-run/:app', component: ProcessRunComponent, canActivate: [AuthGuard] },
  { path: 'AncSettings', component: AncSettingsComponent, canActivate: [AuthGuard] },
  { path: 'manageSeedKeywords/:app', component: SeedShowComponent, canActivate: [AuthGuard] },
  { path: 'managestandardKey', component: SeedShowDealerComponent, canActivate: [AuthGuard] },


  { path: 'signup', component: SignupComponent },
  { path: 'admaker', component: AdmakerComponent },
  { path: 'login', component: LoginComponent }

];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
  providers:[AuthGuard]
})
export class AppRoutingModule { }
